import { ReactNode, HTMLProps, PropsWithChildren } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core";

type GroupOwnProps = PropsWithChildren<{
  action?: ReactNode;
}>;

export type GroupProps = GroupOwnProps & Omit<HTMLProps<HTMLDivElement>, keyof GroupOwnProps>;

export const Group = ({ action, children, ...props }: GroupProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root} {...props}>
      <div className={classes.content}>
        {children}
        {action ? <div className={classes.action}>{action}</div> : null}
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#fbfbfb", // TODO: this is not a color from the styleguide
      padding: `${theme.spacing(2)}px ${theme.spacing(2.5)}px 0`,
    },
    content: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      position: "relative",
    },
    action: {
      position: "absolute",
      top: 0,
      right: 0,
    },
  }),
);
